import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TextMaskService } from '@bayclubs/ui-text-mask';

import { DeviceService } from '@bayclubs/utils';

@Component({
    selector: 'app-credit-card',
    templateUrl: './credit-card.component.html',
    styleUrls: ['./credit-card.component.scss'],
    standalone: false
})
export class CreditCardComponent implements OnInit {
    @Input()
    public form: UntypedFormGroup;

    public securityCodePopoverVisible = false;

    constructor(public device: DeviceService, public mask: TextMaskService) {}

    ngOnInit() {}

    public onSecurityCodeOver(): void {
        this.securityCodePopoverVisible = true;
    }

    public onSecurityCodeOut(): void {
        this.securityCodePopoverVisible = false;
    }

    public get getMaxExpiryDateFromYearControl() {
        if (!this.form.controls.expirationDate.errors) {
            return null;
        }
        let expiryDate = this.form.controls.expirationDate.errors['expiryDateInTheFuture'];
        return expiryDate ? expiryDate.maxDate : null;
    }

    public get getMaxExpiryDateFromMonthControl() {
        if (!this.form.controls.expirationDate.errors) {
            return null;
        }
        let expiryDate = this.form.controls.expirationDate.errors['expiryDateInTheFuture'];
        return expiryDate ? expiryDate.maxDate : null;
    }
}
